import { Fragment } from 'react';
import { Routes, Route } from 'react-router-dom';
import { Outlet } from '@usas/ui-web/wrappers/ReactRouterDom';

import useNavRoutes from '@usas/ui-web/state/security/UseNavRoutes';

import SecuredRouteElement from '@usas/ui-web/components/security/SecuredRouteElement';
import LoadingModal from '@usas/ui-web/components/dialogs/LoadingModal';
import PageNotFound from '@usas/ui-web/components/PageNotFound';
import UnexpectedError from '@usas/ui-web/components/UnexpectedError';

// import LandingPage from './views/landingPage/LandingPage';
import RefundTool from './views/refundTool/RefundTool';
import ErrorBoundary from '@usas/ui-web/components/errors/ErrorBoundary';
import ErrorBoundaryFallback from '@usas/ui-web/components/errors/ErrorBoundaryFallback';

const AppRoutes = () => {
  const { navRoutes, isReadyToRoute } = useNavRoutes();

  if (isReadyToRoute !== true) {
    return <LoadingModal />;
  }

  return (
    <ErrorBoundary fallback={<ErrorBoundaryFallback />}>
      <Routes>
        <Route path="/" element={<Fragment><Outlet /></Fragment>}>
          <Route path={navRoutes.LANDING_ROOT?.path}
            element={
              <SecuredRouteElement
                navRoute={navRoutes.LANDING_ROOT}
                editElement={<RefundTool />} />
            }
          />
          <Route path="500" element={<UnexpectedError />} />
          <Route path="/*" element={<PageNotFound />} />
        </Route>
      </Routes>
    </ErrorBoundary>
  );
};

export default AppRoutes;